import React from 'react';
import type { ProductProps, RichTextEntryType } from 'tsconfig/types';
import { CaseSelectors } from './CaseSelectors';
import { ProductLabel } from './ProductLabel';
import { ProductPricing } from './ProductPricing';
import { renderRating } from './renderRating';
import { UpsellSelector } from './UpsellSelector';
import { AddToCartSection } from './AddToCartSection';
import { CmsRichText } from '../../CmsRichText/CmsRichText';
interface Props {
  eyebrow: string;
  paragraph: RichTextEntryType | null;
  headline: string;
  subheadline: string;
  activeProduct: ProductProps | null;
  upsellProduct: ProductProps | null;
  upsellSelected: boolean;
  products: ProductProps[];
  activeCase: number;
  cartItems: any;
  isMobileView: boolean;
  handleCaseClick: (index: number) => void;
  handleUpsellClick: () => void;
  handleViewTabPanelClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const ProductDetailsSection = ({
  eyebrow,
  paragraph,
  headline,
  subheadline,
  activeProduct,
  upsellProduct,
  upsellSelected,
  products,
  activeCase,
  cartItems,
  isMobileView,
  handleCaseClick,
  handleUpsellClick,
  handleViewTabPanelClick,
}: Props) => (
  <div className="mcs-main__details" data-testid="product-details-section">
    <div className="mcs-main-row">
      <h1>{headline || activeProduct?.name}</h1>
      {subheadline && <div className="mcs-main__sub-headline h7">{subheadline}</div>}
    </div>
    {activeProduct && (
      <div className="mcs-main-row mcs-main-row--active-info">
        <ProductLabel product={activeProduct} upsellProduct={upsellProduct} upsellSelected={upsellSelected} />
        <div className="mcs-price-rating">
          <ProductPricing product={activeProduct} upsellProduct={upsellProduct} upsellSelected={upsellSelected} />
          {renderRating(activeProduct)}
        </div>
      </div>
    )}
    <CaseSelectors
      id="cms-multi-case-selector-list"
      className="mcs-main-row mcs-selector-wrap"
      target="#panel-case-selector"
      activeCase={activeCase}
      products={products}
      handleCaseClick={handleCaseClick}
      handleViewTabPanelClick={handleViewTabPanelClick}
    />

    <UpsellSelector
      upsellProduct={upsellProduct}
      upsellSelected={upsellSelected}
      handleUpsellClick={handleUpsellClick}
      index={products.length}
    />
    <AddToCartSection
      cartItems={cartItems}
      hit={upsellSelected && upsellProduct ? [products[activeCase], upsellProduct] : products[activeCase]}
    />

    {isMobileView && (
      <div className="mcs-main-desc">
        {eyebrow && <span className="eyebrowRegular">{eyebrow}</span>}
        {paragraph && <CmsRichText contentItem={paragraph} />}
      </div>
    )}
  </div>
);
